import { useCallback } from 'react'
import { GraphQLError } from 'graphql'
import { useApolloErrorMessages, useGraphQLErrorMessage } from './apollo-error-message'
import { ApolloError } from '@apollo/client'

export default function useGetErrorMessage() {
  const getGraphQLErrorMessage = useGraphQLErrorMessage()
  const getApolloErrorMessages = useApolloErrorMessages()

  const getErrorHandlerMessages = useCallback(
    (e: unknown): string[] => {
      if (e === null || e === undefined) {
        return []
      }
      if (Array.isArray(e)) {
        return e.map((ee) => getErrorHandlerMessages(ee)).flat()
      }
      if (e instanceof GraphQLError) {
        const m = getGraphQLErrorMessage(e)
        return m ? [m] : []
      }
      if (e instanceof ApolloError) {
        return getApolloErrorMessages(e)
      }
      if (e instanceof Error) {
        return [e.message]
      }
      if (typeof e === 'string') {
        return [e]
      }
      return []
    },
    [getGraphQLErrorMessage, getApolloErrorMessages],
  )
  return getErrorHandlerMessages
}
